import React from "react";
import plus from "../../assets/plus.png";
import data from "./data";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

const Questions = ({ className }) => {
  return (
    <div className={className}>
      <h4 className="font-extrabold text-[26px] sm:text-[28px] xl:text-[30px] lg:text-[36px] leading-[40px] sm:leading-[48px] text-white text-left">
        Frequently Asked <span className="text-[#FE61BD]">Questions</span>
      </h4>
      <div className="flex items-center justify-start flex-wrap gap-5 mt-8">
        {data?.QUESTIONS?.map((obj, i) => {
          return (
            // <div className="bg-[#1a1a1a] rounded-[8px] py-[16px] px-[24px] min-h-[60px] flex justify-between items-center">
            //   <p className="font-medium text-[14px] sm:text-[16px] xl:text-[18px] leading-[22px] sm:leading-[26px] xl:leading-[28px] text-white text-left">
            //     {obj?.question}
            //   </p>
            //   <img src={plus} alt="" className="size-[28px] cursor-pointer" />
            // </div>
            <Accordion
              key={i}
              className="!bg-[#1a1a1a] !rounded-[8px] !py-[16px] !px-[24px] !w-full sm:!w-[48%]"
            >
              <AccordionSummary
                expandIcon={
                  <img
                    src={plus}
                    alt=""
                    className="size-[28px] cursor-pointer"
                  />
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <p className="font-medium text-[14px] sm:text-[16px] xl:text-[18px] leading-[22px] sm:leading-[26px] xl:leading-[28px] text-white text-left">
                  {obj?.question}
                </p>
              </AccordionSummary>

              <AccordionDetails>
                <p className="font-medium text-[14px] sm:text-[16px] xl:text-[18px] leading-[22px] sm:leading-[26px] xl:leading-[28px] text-white text-left">
                  {obj?.answer}
                </p>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};

export default Questions;
